import { Fade } from 'react-awesome-reveal';

const Description = () => {
	return (
		<Fade>
			<div className='center_wrapper'>
				<h2>Highlights</h2>
			</div>
			<div className='highlight_description'>
				"Sed ut perspiciatis unde omnis iste natus error sit voluptatem
				accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab
				illo inventore veritatis et quasi architecto beatae vitae dicta sunt
				explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut
				odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
				voluptatem sequi nesciunt.
			</div>
		</Fade>
	);
};

export default Description;
